"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var nav_right_icon_svg_1 = __importDefault(require("res/img/nav-right-icon.svg"));
var Breadcrumb = function (_a) {
    var items = _a.items;
    return (react_1.default.createElement("nav", { className: 'breadcrumb', "aria-label": 'Breadcrumb' },
        react_1.default.createElement("ol", { className: 'flex flex-row' }, items.map(function (item, i) { return (react_1.default.createElement("li", { key: "br_li_" + i, className: 'flex flex-row' },
            react_1.default.createElement(react_router_dom_1.NavLink, { to: item.href, title: item.text }, item.text),
            react_1.default.createElement("img", { src: nav_right_icon_svg_1.default, alt: 'Break' }))); }))));
};
exports.default = Breadcrumb;
